<section id="categories" *ngIf="isShow">
  <categories></categories>
</section>
<section id="produits">
  <produits></produits>
</section>